export const footerStyles = {
  box: {
    backgroundColor: "rgb(56, 54, 56)",
    padding: "16px 8px",
    display: "flex",
    flexDirection: "row",
  },
  contentContainer: {
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  linkGrid: {
    alignItems: "center",
    marginBottom: 4,
  },
  button: {
    color: "#FFFFFF",
    textTransform: "none",
    textAlign: "left",
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  socialMediaBox: {
    borderBottom: "1px solid #ddd",
    paddingBottom: "8px",
    marginBottom: 1,
    paddingLeft: "28px",
    maxWidth: 500,
  },
  developedBox: { textAlign: "center", color: "#ddd", fontSize: 14 },
};
